// Remembers the Keycast team a restaurant setup created, so a retried setup reuses it.
//
// Key exports: rememberSetupTeam, readSetupTeam, forgetSetupTeam, setupTeamKey.
// Neighbours: components/NewRestaurantSetup.tsx (the only caller).
//
// Setup creates a team first and finishes the key, bunker and server steps after it. A
// failure after the team exists used to leave it behind, and the retry created another
// team with the same name. The id is kept in sessionStorage until setup completes. A
// second restaurant with the same name, set up on purpose later, still gets its own team.

const PREFIX = 'synvya_setup_team'

export function setupTeamKey(personalPubkey: string, restaurantName: string): string {
  return `${PREFIX}:${personalPubkey}:${restaurantName.trim().toLowerCase()}`
}

export function rememberSetupTeam(personalPubkey: string, restaurantName: string, teamId: number): void {
  try {
    sessionStorage.setItem(setupTeamKey(personalPubkey, restaurantName), String(teamId))
  } catch {
    // Storage can be blocked; the setup then behaves as before.
  }
}

export function readSetupTeam(personalPubkey: string, restaurantName: string): number | null {
  try {
    const raw = sessionStorage.getItem(setupTeamKey(personalPubkey, restaurantName))
    if (raw === null) return null
    const id = Number(raw)
    return Number.isInteger(id) && id > 0 ? id : null
  } catch {
    return null
  }
}

export function forgetSetupTeam(personalPubkey: string, restaurantName: string): void {
  try {
    sessionStorage.removeItem(setupTeamKey(personalPubkey, restaurantName))
  } catch {
    // Nothing to clear.
  }
}
